import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  FilterJsonExactlyMatching,
  formateDate,
  SortTheList,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import { useSearchParams } from "react-router-dom";
import { showErrorMessage } from "../Shared/Toast";

function Discount() {
  const [searchParams] = useSearchParams();
  const selectedMoverID: any = searchParams.get("ID");
  const globalState = useGlobalState();
  const [isAnimation, setIsAnimation] = useState(false);
  const [isAddNew, setIsAddNew] = useState(0);
  const [addEditObject, setAddEditObject] = useState<any>({
    PTDiscountTypeID: "0",
    MNVBaseID: "-1",
    PTDiscountID: "-1",
    Name: "",
    BaseID: "-1",
    ObjectTypeID: "-1",
    ObjectID: "-1",
    Object: "",
    Tier1: "",
    StartDate: new Date(),
    EndDate: new Date(),
    Tier1Add: "",
    Tier2: "",
    Tier2Add: "",
    Tier3: "",
    Tier3Add: "",
    DTPmile: "",
    PTDmile: "",
    DTDmile: "",
    PerStairRate: "",
  });

  const [screenListData, setScreenListData] = useState<any>([]);
  const [screenData, setScreenData] = useState<any>([]);

  useEffect(() => {
    getScreenListData();
    getScreenData();
  }, []);

  function getScreenListData() {
    setIsAnimation(true);
    axiosAuth
      .get(
        AppContext.APIURL +
          "api/PTDiscount/PTDiscountGetCompleteDataSetForForeignKeys",
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;

          var l_arrTypes = [
            { PID: 1, Name: "Driver" },
            { PID: 2, Name: "Helper" },
          ];
          l_oResponse.push(l_arrTypes);

          var l_arrTiers = [
            { PID: 1, Name: "1" },
            { PID: 2, Name: "2" },
            { PID: 3, Name: "3" },
          ];
          l_oResponse.push(l_arrTiers);

          setScreenListData(l_oResponse);
        }
        // setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function getScreenData() {
    setIsAnimation(true);
    axiosAuth
      .get(AppContext.APIURL + "api/PTDiscount/PTDiscountGetCompleteGridData")
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0];
          l_oResponse = FilterJsonExactlyMatching(
            l_oResponse,
            "IsDeleted",
            false,
          );
          const deepCopy1 = JSON.parse(JSON.stringify(l_oResponse));
          const deepCopy2 = JSON.parse(JSON.stringify(l_oResponse));
          setThisGridListDataWithoutFilters(deepCopy1);
          setThisGridListData(deepCopy2);
          thisGridListDataRef.current = deepCopy2;
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function checkValidation() {
    var IsOkay = true;
    if (
      !addEditObject.PTDiscountTypeID ||
      addEditObject.PTDiscountTypeID == 0
    ) {
      showErrorMessage("Please select Discount Type");
      IsOkay = false;
    } else if (!addEditObject.Title || addEditObject.Title == "") {
      showErrorMessage("Please enter Title");
      IsOkay = false;
    } else if (!addEditObject.Code || addEditObject.Code == "") {
      showErrorMessage("Please enter Code");
      IsOkay = false;
    } else if (
      !addEditObject.DiscountValue ||
      addEditObject.DiscountValue == ""
    ) {
      showErrorMessage("Please enter Discount Value");
      IsOkay = false;
    } else if (!addEditObject.Quantity || addEditObject.Quantity == "") {
      showErrorMessage("Please enter quantity");
      IsOkay = false;
    } else if (!addEditObject.StartDate || addEditObject.StartDate == "") {
      showErrorMessage("Please select start date");
      IsOkay = false;
    } else if (!addEditObject.EndDate || addEditObject.EndDate == "") {
      showErrorMessage("Please select end date");
      IsOkay = false;
    }

    if (IsOkay == true) {
      saveScreenData();
    }
  }

  function saveScreenData() {
    setIsAnimation(true);
    let object = {} as any;
    object.ObjectType = addEditObject.ObjectTypeID;
    object.PTDiscountID = addEditObject.PTDiscountID;
    object.ObjectID = addEditObject.ObjectID;
    object.PTDiscountTypeID = addEditObject.PTDiscountTypeID;
    object.ObjectType = addEditObject.ObjectType;
    // object.PTDiscountTypeName = addEditObject.PTDiscountTypeName;
    object.Title = addEditObject.Title;
    object.Code = addEditObject.Code;
    object.Description = addEditObject.Description;
    object.DiscountValue = addEditObject.DiscountValue;
    object.Quantity = addEditObject.Quantity;
    object.QuantityConsumed = addEditObject.QuantityConsumed;
    object.IsActive = addEditObject.IsActive;
    object.StartDate = addEditObject.StartDate;
    object.EndDate = addEditObject.EndDate;

    axiosAuth
      .post(AppContext.APIURL + "api/PTDiscount/PTDiscountSave", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          if (l_response && l_response[0] && l_response[0].Status == 0) {
            showErrorMessage(l_response[0].Message);
          } else {
            setIsAddNew(0);
            getScreenData();
          }
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function deleteThisRecord(pid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.PTDiscountID = pid;
    axiosAuth
      .post(AppContext.APIURL + "api/PTDiscount/PTDiscountDeleteRecord", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
          getScreenData();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        deleteThisRecord(obj.SelectedID);
      }
    }
    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({
        x: event.clientX,
        y: event.clientY,
        totalWidth: window.innerWidth,
        totalHeight: window.innerHeight,
      });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = [];
    l_data = [...FilterData];
    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setThisGridListData(deepCopy);
    thisGridListDataRef.current = deepCopy;
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  const [filters, setFilters] = useState(["", "D"]);

  useLayoutEffect(() => {
    SetSortingImage();
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "PTDiscountTypeName")) {
        (
          document.getElementById(
            "imgSort" + "PTDiscountTypeName",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "Title")) {
        (
          document.getElementById("imgSort" + "Title") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "Code")) {
        (
          document.getElementById("imgSort" + "Code") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1],
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />

      {thisGridListData && thisGridListData.length > 0 && (
        <ColumnFilterCheckboxList
          DataType={1}
          RefreshFilters={refreshFilters}
          ClearFilters={clearFilters}
          GridData={thisGridListData}
          ColumnName={selectedColumnName}
          ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
          GetFilteredLists={getFilteredLists}
          ReturnAllFilterdLists={{}}
          ClickPosition={clickPosition}
          Orientation={"Center"}
          ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
        />
      )}

      {isAddNew == 0 && (
        <>
          <div className="flex-d justify-btw mb-10">
            <span></span>
            <div className="flex-daj flex-gap10">
              <a
                className="link-btn btn-link-m"
                onClick={() => ClearAllFilters()}
              >
                Clear All Filters
              </a>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    setAddEditObject({
                      PTDiscountTypeID: "0",
                      MNVBaseID: "0",
                      PTDiscountID: "0",
                      Name: "",
                      BaseID: "0",
                      ObjectTypeID: "0",
                      ObjectID: "0",
                      Object: "",
                      Tier1: "",
                      Tier1Add: "",
                      Tier2: "",
                      Tier2Add: "",
                      Tier3: "",
                      Tier3Add: "",
                      DTPmile: "",
                      PTDmile: "",
                      DTDmile: "",
                      PerStairRate: "",
                      StartDate: new Date(),
                      EndDate: new Date(),
                    });
                    setIsAddNew(1);
                  }}
                >
                  Add New
                </a>
              </div>
              <a
                className="btn-primary flex-daj btn-grid"
                title="Export"
                onClick={() =>
                  DownloadClientsDataInExcel("tbldiscount", "Discount")
                }
              >
                <img src="images/export.svg" width="18" height="18" />
              </a>
            </div>
          </div>
          <div className="flow-auto">
            <table className="reuse-table" id="tbldiscount">
              <thead>
                <tr>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Discount Type
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "PTDiscountTypeName")
                          }
                          data-function="ShowColumnFilterList"
                          title={"Search By Discount Type Name"}
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() =>
                            LoadWithSelectedSort("PTDiscountTypeName")
                          }
                          title={"Sort By Base"}
                        >
                          <span id={"imgSort" + "PTDiscountTypeName"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Title
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "Title")}
                          data-function="ShowColumnFilterList"
                          title={"Search By Title"}
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("Title")}
                          title={"Sort By Object Type"}
                        >
                          <span id={"imgSort" + "Title"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Code
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "Code")}
                          data-function="ShowColumnFilterList"
                          title={"Search By Code"}
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("Code")}
                          title={"Sort By Code"}
                        >
                          <span id={"imgSort" + "Code"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  {/* <th>Description</th> */}
                  <th>Discount Value</th>
                  <th>Quantity</th>
                  <th>Quantity Consumed</th>
                  <th>Is Active</th>
                  <th>Start Date</th>
                  {/* <th>Discount Category</th>
                <th>General Setting 1</th> */}
                  <th>End Date</th>
                  {/* <th>General Setting 2</th>
                <th>General Setting 3</th>
                <th>General Setting 4</th>
                <th>Recurring Discount</th>
                <th>Object Type</th>
                <th>Object ID</th>
                <th>Created By Name</th>
                <th>Created By Username</th>
                <th>Creation Time stamp</th>
                <th>Last Updated By Name</th>
                <th>Last Updated By Username</th>
                <th>Last Updated Time stamp</th>
                <th>Is Deleted</th> */}
                  <th className="td-xxxs">Action</th>
                </tr>
              </thead>
              <tbody>
                {thisGridListData &&
                  thisGridListData.map((item: any, index: any) => (
                    <React.Fragment key={index}>
                      {!item.IsExcluded && (
                        <tr>
                          <td>{item.PTDiscountTypeName}</td>
                          <td>{item.Title}</td>
                          <td>{item.Code}</td>
                          {/* <td>{item.Description}</td> */}
                          <td className="text-right">{item.DiscountValue}</td>
                          <td className="text-right">{item.Quantity}</td>
                          <td className="text-right">
                            {item.QuantityConsumed}
                          </td>
                          <td>{item.IsActive == true ? "true" : "false"}</td>
                          <td>{formateDate(item.StartDate)}</td>
                          {/* <td>{item.DiscountCategory}</td>
                        <td>{item.GeneralSetting1}</td> */}
                          <td>{formateDate(item.EndDate)}</td>
                          {/* <td>{item.GeneralSetting2}</td>
                        <td>{item.GeneralSetting3}</td>
                        <td>{item.GeneralSetting4}</td>
                        <td>{item.RecurringDiscount}</td>
                        <td>{item.ObjectType}</td>
                        <td>{item.ObjectID}</td>
                        <td>{item.CreatedByName}</td>
                        <td>{item.CreatedByUserName}</td>
                        <td>{formateDate(item.CreationTimestamp)}</td>
                        <td>{item.LastUpdatedByName}</td>
                        <td>{item.LastUpdatedByUserName}</td>
                        <td>{formateDate(item.LastUpdatedTimestamp)}</td>
                        <td>{item.IsDeleted == true ? "true" : "false"}</td> */}
                          <td className="td-xxxs">
                            <div className="flex-daj gap-10">
                              <a
                                onClick={() => {
                                  setIsAddNew(2);
                                  setAddEditObject({
                                    PTDiscountTypeID: item.PTDiscountTypeID,
                                    PTDiscountID: item.PTDiscountID,
                                    ObjectTypeID: item.ObjectTypeID,
                                    ObjectID: item.ObjectID,
                                    Title: item.Title,
                                    Code: item.Code,
                                    Name: item.Name,
                                    Description: item.Description,
                                    DiscountValue: item.DiscountValue,
                                    Quantity: item.Quantity,
                                    QuantityConsumed: item.QuantityConsumed,
                                    IsActive: item.IsActive,
                                    StartDate: item.StartDate,
                                    EndDate: item.EndDate,
                                  });
                                }}
                              >
                                <img
                                  src="images/edit.svg"
                                  width="18px"
                                  height="18px"
                                  alt="Edit"
                                />
                              </a>
                              <a
                                onClick={() =>
                                  globalState.setConfirmationModalObject({
                                    ShowPopup: true,
                                    Heading: "Alert",
                                    Message:
                                      "Are your sure, you want to delete this record?",
                                    ID: 1,
                                    SelectedID: item.PTDiscountID,
                                    OtherID: 0,
                                  })
                                }
                              >
                                <img
                                  src="images/delete.png"
                                  width="18px"
                                  height="18px"
                                  alt="Delete"
                                />
                              </a>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {(isAddNew == 1 || isAddNew == 2) && (
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <>
            <div className="grid-d fr-111 gap-20">
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">
                  Discount Type:
                </span>
                <select
                  className="input-field w-100"
                  value={addEditObject.PTDiscountTypeID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      PTDiscountTypeID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Discount type</option>
                  {screenListData[0] &&
                    screenListData[0].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PTDiscountTypeID}>
                          {item.Name}
                        </option>
                      </React.Fragment>
                    ))}
                </select>
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Title:</span>
                <input
                  className="input-field w-100"
                  value={addEditObject.Title}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Title: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Code:</span>
                <input
                  className="input-field w-100"
                  value={addEditObject.Code}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Code: e.target.value,
                    }))
                  }
                />
              </div>
              {/* <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">
                  Discount To:
                </span>
                <select
                  className="input-field w-100"
                  value={addEditObject.ObjectID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      ObjectID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Discount to</option>
                  {screenListData[1] &&
                    screenListData[1].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PTAffiliateID}>{item.Title}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div> */}
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Discount Value:
                </span>
                <input
                  className="input-field w-100"
                  // placeholder="Tier 1 Admin Charges"
                  type="number"
                  value={addEditObject.DiscountValue}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      DiscountValue: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Quantity:</span>
                <input
                  className="input-field w-100"
                  // placeholder="Tier 2"
                  type="number"
                  value={addEditObject.Quantity}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Quantity: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Quantity Consumed:
                </span>
                <input
                  className="input-field w-100"
                  value={addEditObject.QuantityConsumed}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      QuantityConsumed: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Start Date:
                </span>
                <input
                  className="input-field w-100"
                  placeholder="Date"
                  type="date"
                  value={moment(addEditObject.StartDate).format("YYYY-MM-DD")}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      StartDate: moment(e.target.value).format("YYYY-MM-DD"),
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">End Date:</span>
                <input
                  className="input-field w-100"
                  placeholder="Date"
                  type="date"
                  value={moment(addEditObject.EndDate).format("YYYY-MM-DD")}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      EndDate: moment(e.target.value).format("YYYY-MM-DD"),
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3 flex-js text-left">
                <span className="font-12 text-left label-color">
                  Is Active:
                </span>
                <input
                  className="wh-auto"
                  type="checkbox"
                  checked={addEditObject.IsActive}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      IsActive: e.target.checked,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Description:
                </span>
                <input
                  className="input-field w-100"
                  value={addEditObject.Description}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Description: e.target.value,
                    }))
                  }
                />
              </div>
            </div>

            <div className="flex-daj gap-10 mt-20">
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => checkValidation()}
                >
                  {isAddNew == 1 ? "Save" : "Update"}
                </a>
              </div>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setIsAddNew(0)}
                >
                  Cancel
                </a>
              </div>
            </div>
          </>
        </div>
      )}
    </div>
  );
}

export default Discount;
